import { Box, Typography, Grid, Card, CardContent, SxProps, Theme } from "@mui/material";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";

export const Pricing = () => {
  return (
    <SectionContainer sx={{ background: "white" }}>
      <SectionTitle>TASの費用体系</SectionTitle>

      <Grid container spacing={4} sx={gridSx}>
        <Grid item xs={12} md={4}>
          <Card sx={pricingCardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h3" sx={cardTitleSx}>
                基本料金
              </Typography>
              <Box sx={priceBoxSx}>
                <Typography sx={priceSx}>120万円〜</Typography>
                <Typography variant="body1" sx={priceUnitSx}>
                  1人月（160時間）
                </Typography>
              </Box>
              <Typography variant="body1" sx={priceDetailSx}>
                時間単価: 7,500円〜
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card sx={featureCardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h3" sx={cardTitleSx}>
                柔軟な契約形態
              </Typography>
              <Box sx={featureListSx}>
                <Typography variant="body1" sx={featureSx}>
                  0.1人月単位での契約が可能
                </Typography>
                <Typography variant="body1" sx={featureSx}>
                  最低0.8人月から契約可能
                </Typography>
                <Typography variant="body1" sx={featureSx}>
                  エンジニアの単価に応じて稼働時間を調整
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card sx={engineerCardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h3" sx={cardTitleSx}>
                エンジニアレベル調整
              </Typography>
              <Box sx={featureListSx}>
                <Typography variant="body1" sx={featureSx}>
                  エンジニアレベルによる工数の調整
                </Typography>
                <Typography variant="body2" sx={noteSx}>
                  ※ジュニア層の場合、2時間の稼働で1時間とみなすなど
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box sx={messageBoxSx}>
        <Typography variant="body1" sx={messageSx}>
          お客様のプロジェクト規模や予算に合わせて、最適なプランをご提案いたします。
        </Typography>
      </Box>
    </SectionContainer>
  );
};

const gridSx: SxProps<Theme> = {
  justifyContent: "center",
  marginBottom: "40px",
};

const pricingCardSx: SxProps<Theme> = (theme) => ({
  height: "100%",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
  backgroundColor: "#E8F5E8",
  border: "2px solid #4CAF50",
});

const featureCardSx: SxProps<Theme> = (theme) => ({
  height: "100%",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
  backgroundColor: "#FFFFFF",
});

const engineerCardSx: SxProps<Theme> = (theme) => ({
  height: "100%",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
  backgroundColor: "#FFF3E0",
  border: "2px solid #FF9800",
});

const cardContentSx: SxProps<Theme> = {
  padding: "40px",
  textAlign: "center",
};

const cardTitleSx: SxProps<Theme> = (theme) => ({
  fontSize: "20px",
  fontWeight: 600,
  marginBottom: "32px",
  color: "#333333",
});

const priceBoxSx: SxProps<Theme> = {
  marginBottom: "20px",
};

const priceSx: SxProps<Theme> = (theme) => ({
  fontSize: {
    md: "32px",
    xs: "24px",
  },
  fontWeight: 700,
  color: "#4CAF50",
  lineHeight: 1,
});

const priceUnitSx: SxProps<Theme> = {
  fontSize: "18px",
  color: "#666666",
  marginTop: "8px",
};

const priceDetailSx: SxProps<Theme> = {
  fontSize: "20px",
  fontWeight: 600,
  color: "#4CAF50",
};

const featureListSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  textAlign: "left",
};

const featureSx: SxProps<Theme> = {
  fontSize: "18px",
  lineHeight: 1.6,
  color: "#333333",
};

const noteSx: SxProps<Theme> = {
  fontSize: "14px",
  color: "#666666",
  fontStyle: "italic",
  marginTop: "8px",
};

const messageBoxSx: SxProps<Theme> = {
  textAlign: "center",
  padding: "40px",
  backgroundColor: "#E3F2FD",
  borderRadius: "12px",
};

const messageSx: SxProps<Theme> = {
  fontSize: "20px",
  fontWeight: 500,
  color: "#333333",
  maxWidth: "600px",
  margin: "0 auto",
};
